// extracted by mini-css-extract-plugin
module.exports = {"contentData":"style_contentData__PsEth","dataElement":"style_dataElement__K56uj"};